export default class validasiTambahan {
    semakanValidasiTambahan(dataHID){
        //21704207010381270001006901
        var dataJR2 = dataHID.dataJR2[0];
        var dataJR5 = dataHID.dataJR5;
        var dataHK1 = dataHID.dataHK1;
        var dataJRE = dataHID.dataJRE;
        var dataHK8 = dataHID.dataHK8;
        var dataBLK_III = dataHID.dataBLK_III;
        var dataBLK_IVc = dataHID.dataBLK_IVc;
    
        var dataBLK_VII_IMBANG = dataHID.dataBLK_VII_IMBANG;
        let listRalat = [];

        console.log(dataHID)
        //console.log(dataJRE)
        //console.log(dataBLK_III) 
        //console.log(dataBLK_VII_IMBANG)
        
        //1
        if(dataJR2.R == "1" && dataJR5.length < 0){
            listRalat.push("Jika R=1 di JR-2, maka perlu ada pengisian di JR-A");
        }
        if(dataJR2.R != "1" && dataJR5.length > 0){
            listRalat.push(" Jika R=2,3,4,5,6,7,8,9,0,99 di JR-2, maka modul tangkapan data tidak boleh dihantar (JAIS, JPP, KWK IRB, KK IRB, PKK IRB, PNP IRB, JPKASB, PENKASR, JPERB mesti dibiarkan kosong)");
        }

        //2
        if(dataJR2.JAIS < dataJR2.JPP){
            listRalat.push("JAIS mesti lebih besar atau sama dengan JPP (JAIS≥JPP)");
        }//settle

        //3
        const countOccurrences = (arr, key, value) => dataJR5.filter(obj => obj["PKIR"] === "01").length;
        if(countOccurrences > 1){
            listRalat.push("Pastikan hanya seorang Ketua Isi Rumah [PKIR=01] bagi 1 HID");
        }//settle

        //4
        const dataKIR = dataJR5.find(obj => obj.PKIR === '01');
        if(dataKIR.PP != "1" || Number(dataKIR.U) < 15){//betul
        //if(dataKIR.PP != "1" || Number(dataKIR.U) > 15){//testing
            listRalat.push("Pastikan Ketua Isi Rumah [PKIR=01] adalah penerima pendapatan [PP=1] dan berumur 15 tahun dan ke atas [U≥15]");
        }//settle

        //5
        const dataAir02 = dataJR5.find(obj => obj.PKIR === '02');
        if(dataAir02){
            if(dataAir02.TP != "2" || Number(dataAir02.U) < 10){
                listRalat.push("Jika ahli adalah isteri/suami iaitu perhubungan dengan ketua isi rumah dikodkan 02 [PKIR=02] maka taraf perkahwinan bagi ahli tersebut mestilah berkahwin [TP=2] dan umur mesti lebih daripada 10 tahun [U≥10]");
            }//settle

            //6
            if((dataKIR.J == "1" && dataAir02.J != "2") || (dataKIR.J == "2" && dataAir02.J != "1")){
                listRalat.push("Sekiranya Jantina adalah Lelaki [1] bagi Ketua Isi rumah [PKIR=01] maka jantina bagi isteri/suami Ketua Isi Rumah [PKIR=02] adalah Perempuan [2] dan begitu sebaliknya (vice versa)");
            }//settle
        }

        //7
        const dataAirBawah10 = dataJR5.filter(obj => obj.U < 10);//edit on 19/6/2024
        if(dataAirBawah10){
            var x=0;
            for(x;x<dataAirBawah10.length;x++){
                if(dataAirBawah10[x].TP != "1"){
                    listRalat.push("NOAIR : "+dataAirBawah10[x].NOAIR+" Jika umur bawah 10 tahun [U<10], maka TP=1 (Tidak pernah berkahwin)");
                }
            }
        }//settle

        //8
        const dataAir = dataJR5.filter(obj => obj.PKIR != "01");
        if(dataAir){
            var i=0;
            for(i;i<dataAir.length;i++){
                if(dataAir[i].PKIR == "03" && dataAir[i].TP != "1"){
                    listRalat.push("NOAIR : "+dataAir[i].NOAIR+" Sekiranya PKIR adalah anak ketua yang belum berkahwin [03] maka TP adalah Tidak Pernah Berkahwin [1]");
                }
                if(dataAir[i].PKIR == "04" && dataAir[i].TP == "1"){
                    listRalat.push("NOAIR : "+dataAir[i].NOAIR+" Sekiranya PKIR adalah anak ketua yang telah berkahwin [04] maka TP tidak boleh Tidak Pernah Berkahwin [1] [TP≠1]");
                }
            }
        }//settle

        const dataIR = dataJR5;
        var a=0;
        for(a;a<dataIR.length;a++){
            //9
            if((dataIR[a].TA == "01" || dataIR[a].TA == "02" || dataIR[a].TA == "03" || dataIR[a].TA == "04" || dataIR[a].TA == "05") && dataIR[a].PP != 1 ){
                listRalat.push("NOAIR : "+dataIR[a].NOAIR+" Jika TA=01, 02, 03, 04, 05, maka PP=1");
            }

            //10
            if(dataIR[a].U == "0" && dataIR[a].TA != 14){
                listRalat.push("NOAIR : "+dataIR[a].NOAIR+" Jika U=0, maka TA=14");
            }

            //11
            if(dataIR[a].PS == "1" && dataIR[a].TA != "09" ){
                listRalat.push("NOAIR : "+dataIR[a].NOAIR+" Jika PS=1, maka TA=09");
            }

            if(dataIR[a].PS == "3" && (dataIR[a].TA == "09" || dataIR[a].TA == "13" || dataIR[a].TA == "14")){
                listRalat.push("NOAIR : "+dataIR[a].NOAIR+" Jika PS=3, maka TA≠09, 13 @ 14");
            }

            //12
            if(((dataIR[a].U >=3 && dataIR[a].U <=17) && dataIR[a].PS == "1") && dataIR[a].TA != "09"){
                listRalat.push("NOAIR : "+dataIR[a].NOAIR+" Jika U=3 hingga 17 dan PS=1, maka TA=09");
            }

            if(((dataIR[a].U >=0 && dataIR[a].U <=9) && dataIR[a].PS == "4") && dataIR[a].TA != "13"){
                listRalat.push("NOAIR : "+dataIR[a].NOAIR+"  Jika U=0 hingga 9 dan PS=4, maka TA=13");
            }

            //13
            //if((dataIR[a].INCS19>0 || dataIR[a].INCS19 != null) && (dataIR[a].TP64<=0 || dataIR[a].TP64 == null)){
            if(dataIR[a].INCS19 > 0 && (dataIR[a].TP64 == 0 || dataIR[a].TP64 == null)){
                listRalat.push("NOAIR : "+dataIR[a].NOAIR+" Jika INCS19>0 , maka TP64>0");
            }

            //14
            if((dataIR[a].TA == "02" || dataIR[a].TA == "03") && dataIR[a].INCS01 <=0){
                listRalat.push("NOAIR : "+dataIR[a].NOAIR+" Jika TA= 02, 03, maka INCS01>0");
            }

            //15
            if((dataIR[a].TA == "01" || dataIR[a].TA == "04" || dataIR[a].TA == "05") && (dataIR[a].INCS21A <=0 || dataIR[a].INCS21A == null) && (dataIR[a].INCS21NA <=0 || dataIR[a].INCS21NA == null)){
                listRalat.push("NOAIR : "+dataIR[a].NOAIR+" Jika TA=01, 04, 05, maka INCS21A>0 dan/atau INCS21NA>0");
            }
        }
          
   //for every NOAIR === pp=1 incs07&08>0 / pp=2 incs07&08 <0 -> hazwan  \(=^u^=)/ 
    const dataRPIR  = dataJR5;
    var b=0;
    var INCS07=0;
    var INCS08=0;  

  for(dataRPIR.NOAIR = 0;dataRPIR.NOAIR<dataRPIR.length;dataRPIR.NOAIR++){

    for(b;b<dataRPIR.length;b++){

    INCS07=   Number(dataRPIR[b].INCS01) + Number(dataRPIR[b].INCS02) + Number(dataRPIR[b].INCS03) + Number(dataRPIR[b].INCS05) 

    INCS08= Number(dataRPIR[b].INCS01) + Number(dataRPIR[b].INCS02) + Number(dataRPIR[b].INCS03) + Number(dataRPIR[b].INCS06) 
    
                 
          if(dataRPIR[b].PP ==1 &&(INCS07<=0 || INCS08<=0 && INCS08<=0 ) ){
                listRalat.push("NOAIR : "+dataRPIR[b].NOAIR+" Jika PP=1, maka nilai INCS07 dan INCS08 mesti melebihi 0");
          }

            if(dataRPIR[b].PP ==2 && (INCS07 > 0 ||INCS08 > 0 && INCS08 > 0) ){
                listRalat.push("NOAIR : "+dataRPIR[b].NOAIR+" Jika PP=2, maka nilai INCS07 dan INCS08 mesti 0");
            }  
        }
    }//settle

        //18 01503104020340120002007501 -> mai
        //const dataJRE1 = dataJRE.find(obj => obj.HID === 1);
        if(dataJRE.length > 1){//betul
            listRalat.push("Pastikan tiada duplikasi HID di Seksyen JR-E hingga JR-H");
        }//settle


        //19 01503104020340120002007501 -> aidas

        const hk1INCS16= dataHK1.every(obj => obj.INCS16 == 0);
        if (dataJRE[0].JMR == "5" && hk1INCS16){//betul
            listRalat.push("Jika JMR=5 mesti ada pengisian di INCS16");
        }//settle

   
        //40801101010970260001003201 -> hid izzah

        //  JMR ==1 OR 3

        if (dataJRE[0].JMR == "1" || dataJRE[0].JMR == "3") {
            let Listitemkod = ['04210001', '04210002', '04210003', '04210004', '04210005', '04210006', '04210007', '04210008', '04210009', '04210010', '04210011', '04210012', '04210013', '04210014', '04210015', '04210016', '04210099'];
            const requiredcode = '90010021'

            
            const exist = Listitemkod.some(value => dataBLK_III.some(obj => obj.KodItem=== value));
            const codeitemdataBLK_III = dataBLK_III.some(obj => obj.KodItem === requiredcode);
            const codeitemBLK_IVc = dataBLK_IVc.some(obj => obj.KodItem === requiredcode);
            const hk8INCS22= dataHK8.every(obj => obj.INCS22 == 0);
            const dataKIR = dataHK8.find(obj => obj.NOAIR === '01'); // TAMBAHAN hid: 10102101020360190001001501

            console.log(exist)
            console.log(codeitemdataBLK_III)
            console.log(codeitemdataBLK_III)
            console.log(hk8INCS22)
            console.log(dataKIR)

            
            if (!exist)
            {
                listRalat.push("Jika JMR = 1 @ 3 mesti ada pengisian di blok 3 (PreCode) dengan kod item 04210001, 04210002, 04210003, 04210004, 04210005, 04210006, 04210007, 04210008, 04210009, 04210010, 04210011, 04210012, 04210013, 04210014, 04210015, 04210016, 04210099");
       
            }
            if (!codeitemdataBLK_III && !codeitemBLK_IVc)
            {
                listRalat.push("Wajib ada pengisian kod item 90010021 di blok 3 atau blok 4c ");
            }

       
            if (hk8INCS22 && dataKIR)
            {
                listRalat.push("NOAIR : 01 " + " Wajib ada pengisian INCS22 > 0");
            }
  
        //}

        //  JMR == 2 OR 4
        if (dataJRE[0].JMR == "2" || dataJRE[0].JMR == "4") {
            let Listitemkod = ['04210001', '04210002', '04210003', '04210004', '04210005', '04210006', '04210007', '04210008', '04210009', '04210010', '04210011', '04210012', '04210013', '04210014', '04210015', '04210016', '04210099'];
            const exist = Listitemkod.some(value => dataBLK_III.some(obj => obj.KodItem=== value));
            if (!exist)
            {
                listRalat.push("Jika JMR = 2 @ 4 mesti ada pengisian di blok 3 dengan kod item 04110001, 04110002, 04110003, 04110004, 04110005, 04110006, 04110007, 04110008, 04110009, 04110010, 04110011, 04110012, 04110013, 04110014, 04110015, 04110016, 04110099");
            }
        }
    }
        // PR == 2
        if (dataJRE[0].PR == "2") {
            const requiredcode = '90020012'
            const requiredcodeitem = dataBLK_III.some(obj => obj.KodItem === requiredcode);
            console.log(requiredcodeitem)
            if (!requiredcodeitem)
            {
                listRalat.push("Jika PR=2 mesti ada pengisian di blok 3 dengan kod item 90020012");
            }
        }
        //atiey
        if (dataJRE[0].SP1 == "1" ||dataJRE[0].SP2 == "1" ||dataJRE[0].SP3 == "1"  ){
            if (dataJRE[0].KS == "3"){
                    listRalat.push("Jika SP adalah Menggunakan kemudahan kutipan sampah [SP=1] maka KS tidak boleh tiada [KS≠3]");
                
            }

        }

        //aidam
        if ( !dataBLK_VII_IMBANG[0].TOT_C >= 90 && dataBLK_VII_IMBANG[0].TOT_C <= 110){
            listRalat.push("Imbangan (C) nilai antara 90% hingga 110%");
         }
         
         //JPERB == jumlah A -> hazwan \(^O^)/ 
            
           // const datajumlahA= dataBLK_III;
           // var total=0;
           // var jumRMNEG=0;
           //  for(i = 0; i< datajumlahA.length; i++){
             //   jumRMNEG = Number(total) + Number(datajumlahA[i].RMNEG);
             //  total= Number(jumRMNEG);
            //  }

        if (dataJR2.JPERB != dataBLK_VII_IMBANG[0].TOT_A)
        {
            listRalat.push("Nilai JPERB mesti sama dengan Jumlah (A) di HES-1/BLK 7");
        }//settle

        return listRalat;
    }
}


